export const INCIDENTS_STRATEGIES = {
  FILTERED_ISSUES: 'filtered_issues',
  REPORTED: 'reported'
};

export const CUSTOM_OPTIONS = {
  // lighthouse: {
  //   code: 'vnw2fw6226',
  //   description: 'Learn more >'
  // },
  [INCIDENTS_STRATEGIES.FILTERED_ISSUES]: {
    confirmation_modal: {
      confirmation_text: 'Detect my incidents based on critical bugs detection',
      modalHeight: '30rem',
      modalWidth: '42rem'
    }
  },
  [INCIDENTS_STRATEGIES.REPORTED]: {
    confirmation_modal: {
      confirmation_text: 'Detect my incidents using API',
      modalHeight: '30rem',
      modalWidth: '42rem'
    }
  }
};

export const INCIDENT_DETECTION_OPTIONS = [
  {
    label: 'Detect my incidents based on critical bugs',
    subtext:
      'LinearB recognize critical bugs based on Project Management (link) setting',
    radio_value: INCIDENTS_STRATEGIES.FILTERED_ISSUES
  },
  {
    adminOnly: true,
    label: 'API Integration',
    blockedMessage:
      'Please contact your admin to be able to select this option',
    subtext: 'Incidents reported via API integration',
    radio_value: INCIDENTS_STRATEGIES.REPORTED,
    withApiToken: true
  }
];
